<template>
    <div>
        <br /><br />
        <br /><br />
        <h1 style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold ">3. ¿Cuándo lo recogemos?</h1>
        <br /><br />
        <br /><br />
        <div>
            <div>
                <label style="font-family: Heebo; font-weight: normal; font-size: 14px">Fecha de recogida *</label> <!--class="title--xs mb-0"-->
                <div>
                    <div  class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                            <input rounded outlined style="color: #9BA19D;font-family: Heebo; font-weight: normal"
                                   type="date" id="mainDate" v-model="datos.fechaRecogida" maxlength="10" name="form_fields[company]"
                                   class="elementor-field elementor-size-sm  elementor-field-textual" :min="diaMinimo">
                    </div>
                        <p class="text--s mt-1 mb-0" style="font-family: Heebo; font-weight: normal">A partir de las 16:00 no se podrá solicitar la recogida para el día siguiente</p>
                        <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ datos.fechaError }}</p>
                    </div>



            </div>
        </div>
    </div>
    <br />
    <br />
    <br />
    <br />
</template>

<script>
    import calcularLaborables from '@/plugins/servicioDiasLaborables'

    export default {
        props: {
            datos: Object
        },
        data: () => ({
            diasLaborables: [],
            diaMinimo: ''
        }),
        created() {
            this.diasLaborables = calcularLaborables(2)

            let today = new Date()
            let diaLogistica
            if (today.getHours() < 16) diaLogistica = this.diasLaborables[0]
            else diaLogistica = this.diasLaborables[1]

            this.diaMinimo = diaLogistica
        }
    }
</script>

<style>
 /*
    #horario .v-input__slot {
        border: 0px solid white;
    }*/
    #mainDate {
        border: none;
        outline: none;
        border-bottom: 1px solid #D3D3D3;
    }
   

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }
    ::placeholder {
        font-family: Heebo;
        color: #606060;
        font-weight: normal;
    }


    #mainDate::before {
        display: none;
    }

    #mainDate::after {
        border-bottom: 1px solid #9be51a !important;
    }
    
</style>